export default __webpack_public_path__ + "static/media/icon-agenda.c4dc8982.svg";